<script>
  import Modal from '@components/general/modal.svelte'
  import Block from '@components/general/block'
  import BoxedText from '@components/general/boxed-text.svelte'
  import Button from '@components/buttons/button.svelte'
  import { formatDateTime } from '@lib/utils/date'
  import { CheckCircle } from 'lucide-svelte'

  let { open = $bindable(false), request, onApprove } = $props()

  let statusVariant = { pending: 'warning', approved: 'success', rejected: 'error' }
</script>

<Modal title="Invoice Request" bind:open avoidFocus>
  {#if request}
    <Block.Items class="mb-4">
      <Block.Item label="User" value={request.user.name} />
      <Block.Item label="Email" value={request.user.email_address} />
      <Block.Item label="Offer" value={request.offer.name} />
      <Block.Item label="Price" value={request.offer.display_price} />
      {#if request.billing_name}
        <Block.Item label="Business name" value={request.billing_name} />
      {/if}
      <Block.Item label="Billing address" value={request.billing_address} />
      {#if request.purchase_order_number}
        <Block.Item label="PO number" value={request.purchase_order_number} />
      {/if}
      {#if request.notes}
        <Block.Item label="Notes" value={request.notes} column />
      {/if}
      <Block.Item label="Submitted" value={formatDateTime(request.created_at)} />
      <Block.Item label="Status">
        <BoxedText variant={statusVariant[request.status]} size="xs" text={request.status} />
      </Block.Item>
    </Block.Items>
  {/if}

  {#snippet footer()}
    {#if request?.status === 'pending'}
      <Button variant="primary" text="Approve" Icon={CheckCircle} onclick={() => onApprove?.(request)} />
    {/if}
  {/snippet}
</Modal>
